import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import getCartHighLightedVouchers from 'store/cart/selector/getCartHighLightedVouchers';
import styles from './BasketHighlightedVouchers.module.scss';
import HighlightedVoucher from './HighlightedVoucher/HighlightedVoucher';

const BasketHighlightedVouchers = () => {
  const promotedVouchers = useSelector(getCartHighLightedVouchers);
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <h1>{t('txt_highlighted_vouchers_header')}:</h1>
      <div className={styles.vouchers}>
        {promotedVouchers.map((voucher, idx) => (
          <HighlightedVoucher key={idx} voucher={voucher} />
        ))}
      </div>
    </div>
  );
};

export default BasketHighlightedVouchers;
